import { set } from 'lodash-es';

export const DefaultValuesService = {
  /**
   * Traverse compilerConfig nodes and provide a structured initial values object
   *
   * @param {object} values Default field values
   * @param {object} compilerConfig[] Compiler components array
   * @param {[string]} path Property path
   * @param {object} accumulator
   */
  supplyValues(values: any, compilerConfig: [any], path: any = [], accumulator = {}): any {
    compilerConfig.forEach(entry => {
      const { key, children } = entry;
      const newPath = path.concat([key]);

      if (children) {
        DefaultValuesService.supplyValues(
          values,
          children,
          newPath,
          accumulator,
        );
      }

      if (values[key]) {
        set(accumulator, newPath.join('.'), values[key]);
      }
    });

    return accumulator;
  },
};

export default DefaultValuesService;
